export const LEVELS = {
  1: {
    label: "Level 1 — Foundational",
    chip: "Level 1 — Foundational",
    description: "Basic cyber hygiene — 17 practices",
    score: 88, met: 15, total: 17, gaps: 2, partials: 2, notimpl: 2,
    ringColor: "var(--green)", ringStatus: "NEAR READY",
    reportScore: "88% — Near Ready",
    domains: [
      { id: "AC", name: "Access Control",       pct: 100, met: 6, total: 6 },
      { id: "IA", name: "Identification & Auth", pct: 100, met: 5, total: 5 },
      { id: "MP", name: "Media Protection",      pct: 67,  met: 2, total: 3 },
      { id: "PE", name: "Physical Protection",   pct: 100, met: 6, total: 6 },
    ],
  },
  2: {
    label: "Level 2 — Advanced",
    chip: "Level 2 — Advanced",
    description: "Advanced cyber hygiene — 110 practices",
    score: 62, met: 68, total: 110, gaps: 24, partials: 18, notimpl: 24,
    ringColor: "var(--accent)", ringStatus: "IN PROGRESS",
    reportScore: "62% — In Progress",
    domains: [
      { id: "AC", name: "Access Control",          pct: 72,  met: 18, total: 25 },
      { id: "AU", name: "Audit & Accountability",  pct: 80,  met: 8,  total: 10 },
      { id: "CM", name: "Config Management",       pct: 55,  met: 5,  total: 9  },
      { id: "IA", name: "Identification & Auth",   pct: 64,  met: 7,  total: 11 },
      { id: "IR", name: "Incident Response",       pct: 83,  met: 5,  total: 6  },
      { id: "MA", name: "Maintenance",             pct: 50,  met: 3,  total: 6  },
      { id: "MP", name: "Media Protection",        pct: 67,  met: 6,  total: 9  },
      { id: "PS", name: "Personnel Security",      pct: 75,  met: 3,  total: 4  },
      { id: "PE", name: "Physical Protection",     pct: 100, met: 6,  total: 6  },
      { id: "RA", name: "Risk Assessment",         pct: 40,  met: 2,  total: 5  },
      { id: "CA", name: "Security Assessment",     pct: 25,  met: 1,  total: 4  },
      { id: "SC", name: "System & Comm Prot",      pct: 56,  met: 9,  total: 16 },
      { id: "SI", name: "System & Info Integrity", pct: 58,  met: 7,  total: 12 },
      { id: "PM", name: "Program Management",      pct: 25,  met: 1,  total: 4  },
    ],
  },
  3: {
    label: "Level 3 — Expert",
    chip: "Level 3 — Expert",
    description: "Expert cyber hygiene — 130+ practices",
    score: 34, met: 44, total: 130, gaps: 52, partials: 34, notimpl: 52,
    ringColor: "var(--red)", ringStatus: "EARLY STAGE",
    reportScore: "34% — Early Stage",
    domains: [
      { id: "AC", name: "Access Control",          pct: 48, met: 14, total: 29 },
      { id: "AU", name: "Audit & Accountability",  pct: 55, met: 7,  total: 13 },
      { id: "CM", name: "Config Management",       pct: 30, met: 4,  total: 13 },
      { id: "IA", name: "Identification & Auth",   pct: 38, met: 5,  total: 13 },
      { id: "IR", name: "Incident Response",       pct: 50, met: 4,  total: 8  },
      { id: "MA", name: "Maintenance",             pct: 33, met: 2,  total: 6  },
      { id: "MP", name: "Media Protection",        pct: 44, met: 4,  total: 9  },
      { id: "PS", name: "Personnel Security",      pct: 60, met: 3,  total: 5  },
      { id: "PE", name: "Physical Protection",     pct: 71, met: 5,  total: 7  },
      { id: "RA", name: "Risk Assessment",         pct: 20, met: 1,  total: 5  },
      { id: "CA", name: "Security Assessment",     pct: 17, met: 1,  total: 6  },
      { id: "SC", name: "System & Comm Prot",      pct: 32, met: 6,  total: 19 },
      { id: "SI", name: "System & Info Integrity", pct: 38, met: 6,  total: 16 },
      { id: "PM", name: "Program Management",      pct: 14, met: 1,  total: 7  },
    ],
  },
};